/**
 * Created by zhoay on 2023/4/22
 * Desc: 毕业相册申请
 */
import React, { Component } from 'react'
import { List, Toast, Form, Stepper } from "antd-mobile";
import { fetchGet, fetchPost, fetchPostObj } from '../../../utils/fetchRequest'
import { API } from '../../../configs/api.config'
import { getSearchParams, isObjEmpty, getIntValue, getStrValue, } from '../../../utils/common'
import { Icon, message, Button, Cascader, InputNumber } from 'antd'
import './PreviewApply.css';
import { connect } from 'react-redux'

class PreviewApply extends Component {

    componentWillMount() {
        document.title = "相册申请";
    }

    constructor(props) {
        super(props)

        this.state = {
            appId: null,
            openId: null,
            schoolData: [],
            optionss: [],
            schoolName: null,
            gradeClazz: null,
            stuName: null,
            psPhone: null,
            detailedAddress: null,
            cascaderValue: [],
            clazzId: this.props.match.params.clazzId,
            schoolId: this.props.match.params.schoolId,
            appId: this.props.match.params.appId,
            openId: this.props.match.params.openId,
            ruleId: this.props.match.params.ruleId,
            changed: 1,
            money: 0,
            upMoney: 0,
            buyType: 2,
        }
    }

    componentDidMount() {
        Toast.loading('努力加载中...', 0)
        this.getSchoolList()
        //this.onChange()

        this.searchParams = getSearchParams(this.props.location.search)

    }

    render() {
        const { schoolData, optionss, schoolName, gradeClazz, stuName, psPhone, detailedAddress, money, upMoney, buyType } = this.state;

        const onChange = (value) => {
            console.log('changed', value);
            this.setState({
                changed: value,
                money: value * upMoney
            })
        };

        return (
            <div className='preview-page-root'>
                <div className='head-preview-page'>
                    <div style={{ textAlign: 'center' }}>
                        <img className='head-word-page' src={require('imgs/Album_b.png')} />
                    </div>
                </div>
                <div className="tail-preview-page">
                    <div className="album-container" ref={node => this.node = node} onChange={this.handelValueCom}>
                        <div style={{ margin: '5px 10px 5px 10px', background: 'white', borderRadius: '10px' }}>
                            <div className="item_sty">
                                <div className="left_title">学校</div><div className={'form-input-fill'}>*</div>
                                <input ref='schoolName' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" disabled="disabled" value={this.state.schoolName} />
                            </div>

                            <div className="comhline_sty1"></div>

                            {buyType == 2?
                            <div className="item_sty">
                                <div className="left_title">班级</div><div className={'form-input-fill'}>*</div>
                                <input ref='gradeClazz' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" disabled="disabled" value={this.state.gradeClazz} />
                            </div>:
                            <div className="item_sty">
                                <div className="left_title">班级</div><div className={'form-input-fill'}>*</div>
                                <input ref='gradeClazz' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.gradeClazz} />
                            </div>}

                            <div className="comhline_sty1"></div>

                            <div className="item_sty">
                                <div className="left_title">姓名</div><div className={'form-input-fill'}>*</div>
                                <input ref='stuName' className="text-right right_input" type="text" placeholder="学生姓名" maxLength={20} autoFocus="autoFocus" value={this.state.stuName} />
                            </div>

                            <div className="comhline_sty1"></div>

                            <div className="item_sty">
                                <div className="left_title">手机号</div><div className={'form-input-fill'}>*</div>
                                <input ref='psPhone' className="text-right right_input" type="text" placeholder="默认电话" maxLength={20} autoFocus="autoFocus" value={this.state.psPhone} />
                            </div>

                            <div className="comhline_sty1"></div>

                            {buyType == 2 ? '' :
                            <div className="item_sty">
                                <div className="left_title">详细地址</div><div className={'form-input-fill'}>*</div>
                                <input ref='detailedAddress' className="text-right right_input" type="text" placeholder="详细地址" maxLength={20} autoFocus="autoFocus" value={this.state.detailedAddress} />
                            </div>
                            }

                            <div className="comhline_sty1"></div>

                            <div className="item_sty">
                                <div className="left_title">订购数量</div>
                                <InputNumber min={1} max={100} defaultValue={1} onChange={onChange} className="right_input" />
                            </div>

                            <div className="comhline_sty1"></div>

                            <div className="item_sty">
                                <div className="left_title">金额</div>
                                <input ref='money' className="text-right right_input" type="text" placeholder="金额" maxLength={20} autoFocus="autoFocus" disabled="disabled" value={this.state.money} />
                            </div>

                            <div className="comhline_sty1"></div>

                            <div style={{ textAlign: 'center', margin: '5px 10px 15px 10px', color: '#3b303099', fontSize: '12px' }}>{buyType == 1 ? '支付完成，毕业相册将邮寄到学校统一发放。' : '支付完成，毕业相册将邮寄到详细地址。'}</div>
                        </div>
                        {/*<Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                            onClick={this.onNextClick}>下一步</Button>*/}
                        <div style={{ textAlign: 'center' }}>
                            {/*<Button className="commonButton" style={{ margin: '20px', white: 'white', backgroundColor: '#34EF2E', textAlign: 'center' }}
                                onClick={this.onNextClick}>付款</Button>*/}
                            <img src={require('imgs/Album_c.png')} width={104} height={52} style={{ margin: '45px', white: 'white', textAlign: 'center' }} onClick={this.onNextClick} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (value) => {

        fetchGet(API.GET_AREA_LIST, {
            // schoolId: this.props.userInfo.teacher.schoolId,
        }).then(response => {
            Toast.hide();
            const { optionss } = this.state;

            if (response && response.data) {
                // const schoolArray = response.data.schools
                const propertyArray = response.data;

                this.setState({
                    optionss: propertyArray
                })
            }

        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    getSchoolList = () => {
        Toast.loading('', 0);

        fetchGet(API.ALBUM_CLAZZ, {
            schoolId: this.state.schoolId,
            clazzId: this.state.clazzId,
            ruleId: this.state.ruleId,
        }).then(response => {
            Toast.hide();
            if (response && response.data) {
                // const schoolArray = response.data.schools
                this.setState({
                    schoolName: response.data.schoolName,
                    gradeClazz: response.data.buyType == 2 ? response.data.gradeClazz:null,
                    upMoney: response.data.upMoney,
                    money: response.data.upMoney,
                    appid: response.data.appid,
                    buyType: response.data.buyType,
                })

            }

        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    onNextClick = (amount) => {

        const { cascaderValue, optionss, schoolName, gradeClazz, stuName, psPhone, detailedAddress, appId, openId, changed, money, upMoney, clazzId, schoolId } = this.state

        let err = ''

        /*if (optionss.length<3) {
                        Toast.fail('请输入省市区')
            return
        }*/
        if (money <= 0) {
            Toast.show('请输入正确的充值金额！')
            return
        }
        if (isObjEmpty(schoolName)) {
            Toast.fail('请输入学校')
            return
        }
        if (isObjEmpty(gradeClazz)) {
            Toast.fail('请输入班级')
            return
        }
        if (isObjEmpty(stuName)) {
            Toast.fail('请输入学生姓名')
            return
        }
        if (isObjEmpty(psPhone)) {
            Toast.fail('请输入手机号')
            return
        }

        const params = {
            //optionss: cascaderValue,
            school_name: schoolName,
            gradeClazz: gradeClazz,
            person_name: stuName,
            person_phone: psPhone,
            number: changed,
            money: upMoney,
            sumMoney: money,
            clazz_id: clazzId,
            school_id: schoolId,
            detailedAddress: detailedAddress,
            type: 2,
            appId: appId,
            openId: openId,
        }

        fetchPost(API.ALBUM_CHARGE_ORDER, { params: JSON.stringify(params) },
            {})
            .then((response) => {
                Toast.hide()
                const data = response.data
                err = data
                if (err === undefined) {
                    err = response.message;
                }
                if (typeof WeixinJSBridge == 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady',
                            this.onBridgeReady(data), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady',
                            this.onBridgeReady(data))
                        document.attachEvent('onWeixinJSBridgeReady',
                            this.onBridgeReady(data))
                    }
                } else {
                    this.onBridgeReady(data)
                }
            }).catch((error) => {
                console.log('error:' + JSON.stringify(error))
                Toast.show('支付失败！' + err)
            })
    }

    onBridgeReady = (json) => {
        console.log('json:', json)
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', JSON.parse(json),
            function (res) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    Toast.success('支付成功！')
                    this.props.history.push('/previewPage/1')
                } else {
                    Toast.fail('支付失败！')
                    this.props.history.push('/previewPage/2')
                }
            })
    }

    handelValueCom = (event) => {
        //获取用户名的值
        let schoolName = this.refs.schoolName.value;
        let gradeClazz = this.refs.gradeClazz.value;
        let stuName = this.refs.stuName.value;
        let psPhone = this.refs.psPhone.value;
        let detailedAddress;
        if (this.state.buyType == 1) {
            detailedAddress = this.refs.detailedAddress.value;
        }
        //获得内容的值
        this.setState({
            schoolName: schoolName,
            gradeClazz: gradeClazz,
            stuName: stuName,
            psPhone: psPhone,
            detailedAddress: detailedAddress,
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo }
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PreviewApply)
